<script>
    import Popup from '../mobile/mobilePop.svelte';
    let first;
    let second;
    let third;
    let join1;
    let join2;
    // let secondtext;
    // let thirdtext;
    // let thirddis;
    // let seconddis;
    let edit = false;
    let state;
    </script>
    
    <div class="main-div">
        <div class="first" 
        role="presentation"
        bind:this={first} on:click={()=>{
            second.style.opacity ='1';
            second.style.zIndex ='5';
            third.style.zIndex ='5';
            third.style.opacity = '1';
            third.style.left = '36.234vw';
            first.style.opacity ='0';
        }}>
            <p style="padding-top: 2vw;">
                Join Governance Council
            </p>
        </div>
        <div 
        role="presentation"
        class="second" bind:this={second} 
          on:click={() => {
            edit = true;
            state = 'Join Governance Council (Youth)';
        }}>
            <p style="padding-top: 2vw;"> Youth</p>
            <div class="joinas" bind:this={join1}>
                <p> Join as</p>
            </div>
    
    
            <!-- <div class="secondtext" bind:this={secondtext}  
          >
                <p class="secondhead"> <span class="span">1000</span><br>
                    seats remaining</p>
                    <p class="seconddiscription" bind:this={seconddis}>
                        You are actively enrolled in school or college and/or under 21
                    </p>
            </div> -->
    
    
        </div>
        <div
        role="presentation"
         class="third" bind:this={third} 
         on:click={() => {
            edit = true;
            state = 'Join Governance Council (Professionals)';
        }}>
            <p style="padding-top: 2vw;"> Professionals</p>
            <div class="joinas" bind:this={join2}>
                <p> Join as</p>
            </div>
    
            <!-- <div class="secondtext" bind:this={thirdtext}>
                <p class="secondhead"> <span class="span">900</span><br>
                    seats remaining</p>
                    <p class="seconddiscription" bind:this={thirddis}>
                        You are a creative or technical professional or an investor
                    </p>
            </div> -->
        </div>
    </div>
    
    {#if edit}
        <Popup
        JoinAs={state};
            on:click={() => {
                edit = false;
            }}
        />
    {/if}
    
    <style>
        p{ 
            margin: 0; 
        }
    .main-div{
        position: relative;
    }
    .first{
        position: absolute;
        width: 60.748vw;
        height: 9.346vw;
        border: 0.234vw solid white;
        background-color: transparent;
        font-size: 2.804vw;
        font-weight: 700;
        color: white;
        text-align: center;
        z-index: 1;
        font-family: "Orbitron";
        opacity: 1;
        transition-duration: 0.8s;
    }
    .first:hover{
        border: 0.052vw solid black;
        color: black;
        background-color: white;
    }
    .second{
        position: absolute;
        margin-left: -5vw;
        width: 29.206vw;
        height: 9.346vw;
        font-size: 2.804vw;
        font-weight: 700;
        color: black;
        text-align: center;
        border: 0.234vw solid black;
        background: white;
        font-family: "Orbitron";
        opacity: 0;
        transition-duration: 0.8s;
        animation: svelte-mxqz43-move 2.5s linear;
    
    }
    .third{
        position: absolute;
        width: 29.206vw;
        height: 9.346vw;
        font-size: 2.804vw;
        font-weight: 700;
        color: black;
        background: white;
        text-align: center;
        border: 0.234vw solid black;
        font-family: "Orbitron";
        opacity: 0;
        transition-duration: 2.5s;
        left: 15vw;
    }
    .joinas{
        width: 12.85vw;
        height: 3.972vw;
        background-color: black;
        font-size: 2.336vw;
        font-weight: 400;
        font-family: "Orbitron";
        position: absolute;
        border-radius: 0.935vw;
        color: white;
        top: -2.3vw;
        left: 1.168vw;
    }
    /* .secondtext{
        position: absolute;
        text-align: left;
        color: black;
        top: 2vw;
        opacity: 0;
        transition-duration: 0.8s;
    }
    .span{
        color:#DA22FF;
        font-size: 0.833vw;
        font-family: "Orbitron";
        font-weight: 700;
    }
    .secondhead{
        font-size: 0.417vw;
        font-family: "Orbitron";
    }
    .seconddiscription{
        width: 10.042vw;
        font-size: 0.521vw;
        font-family: "Orbitron";
        line-height: 0.729vw;
        transition-duration: 0.75s;
    } */
    @keyframes move{
        0%{
            width: 10vw;
        }
        100%{
            width: 7vw;
        }
    }
    </style>